export const closeSVG = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 5L5 13M13 13L5 5" stroke="black" strokeWidth="2" strokeLinecap="round" />
  </svg>
)
